import produce from 'immer';
import { includes, reject } from 'lodash/fp';
import * as actions from './actions';

export const initialState = {
  draft: { data: null, loading: false, error: null },
  drafts: { data: null, loading: false, error: null },
  created: { data: {}, loading: {}, error: {} },
  deleted: { data: {}, loading: {}, error: {} },
  updated: { data: {}, loading: {}, error: {} },
};

const reducer = (state = initialState, action) => produce(state, (draft) => {
  switch (action.type) {
    case actions.CREATE_DRAFT_REQUEST:
      draft.created.loading.draft = true;
      break;
    case actions.CREATE_DRAFT_SUCCESS:
      draft.created.loading.draft = false;
      draft.created.data.draft = action.payload.draft;
      break;
    case actions.CREATE_DRAFT_FAILURE:
      draft.created.loading.draft = false;
      draft.created.error.draft = action.payload.error;
      break;
    case actions.UPDATE_DRAFT_REQUEST:
      draft.updated.loading.draft = true;
      break;
    case actions.UPDATE_DRAFT_SUCCESS:
      draft.updated.loading.draft = false;
      draft.updated.data.draft = true;
      break;
    case actions.UPDATE_DRAFT_FAILURE:
      draft.updated.loading.draft = false;
      draft.updated.error.draft = action.payload.error;
      break;
    case actions.FETCH_DRAFT_REQUEST:
      draft.draft.loading = true;
      break;
    case actions.FETCH_DRAFT_SUCCESS:
      draft.draft.loading = false;
      draft.draft.data = { ...draft.draft.data, ...action.payload.draft };
      break;
    case actions.FETCH_DRAFT_FAILURE:
      draft.draft.loading = false;
      draft.draft.error = action.payload.error;
      break;
    case actions.FETCH_DRAFTS_REQUEST:
      draft.drafts.loading = true;
      break;
    case actions.FETCH_DRAFTS_SUCCESS:
      draft.drafts.loading = false;
      draft.drafts.data = action.payload.drafts;
      break;
    case actions.FETCH_DRAFTS_FAILURE:
      draft.drafts.loading = false;
      draft.drafts.error = action.payload.error;
      break;
    case actions.DELETE_DRAFT_REQUEST:
      draft.deleted.loading.draft = true;
      break;
    case actions.DELETE_DRAFT_SUCCESS:
      draft.deleted.loading.draft = false;
      draft.drafts.data = reject(d => d.id === action.payload.did, draft.drafts.data);
      break;
    case actions.DELETE_DRAFT_FAILURE:
      draft.deleted.loading.draft = false;
      draft.deleted.error.drafts = action.payload.error;
      break;
    case actions.DELETE_DRAFTS_REQUEST:
      draft.deleted.loading.drafts = true;
      break;
    case actions.DELETE_DRAFTS_SUCCESS:
      draft.deleted.loading.drafts = false;
      draft.drafts.data = reject(d => includes(d.id, action.payload.dids), draft.drafts.data);
      break;
    case actions.DELETE_DRAFTS_FAILURE:
      draft.deleted.loading.drafts = false;
      draft.deleted.error.drafts = action.payload.error;
      break;
    case actions.FETCH_DRAFT_FILE_SUCCESS:
      draft.draft.data = { ...draft.draft.data, blob: action.payload.blob };
      break;
    case actions.FETCH_DRAFT_FILE_FAILURE:
      draft.draft.data = { ...draft.draft.data, blob: null };
      draft.draft.error = action.payload.error;
      break;
    case actions.CLEAR_DRAFTS_ERROR:
      draft.drafts.error = null;
      break;
    case actions.CLEAR_CREATED_ERROR_DRAFT:
      draft.created.error.draft = null;
      break;
    case actions.CLEAR_UPDATED_ERROR_DRAFT:
      draft.updated.error.draft = null;
      break;
    case actions.CLEAR_DELETED_ERROR_DRAFTS:
      draft.deleted.error.drafts = null;
      break;
    case actions.CLEAR_DRAFT_ERROR:
      draft.draft.error = null;
      break;
    case actions.INIT_CREATED:
      draft.created = { data: {}, loading: {}, error: {} };
      break;
    case actions.INIT_UPDATED:
      draft.updated = { data: {}, loading: {}, error: {} };
      break;
    case actions.INIT_DELETED:
      draft.deleted = { data: {}, loading: {}, error: {} };
      break;
    case actions.INIT_DRAFT:
      draft.draft = { data: null, loading: false, error: null };
      break;
    case actions.INIT_DRAFTS:
      draft.drafts = { data: null, loading: false, error: null };
      break;
    default:
  }
});

export default reducer;
